import React, { useState } from 'react';
import './Contact.css';
import Button from '../Button/Button';
import contactImg from '../../Assets/Contact.png'; // Path to your image

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Submitted:", formData);
    // Add your email logic here
  };

  return (
    <section className="contact-section">
      <div className="contact-container">
        
        {/* LEFT: Info & Image Section */}
        <div className="contact-info">
          <h2 className="contact-title">Request for Quote</h2>
          <p className="contact-subtitle">
            Tell us your insulation requirements, and we'll deliver a prompt and precise quotation.
          </p>
          <div className="contact-image-wrapper">
            <img src={contactImg} alt="Office desk with calculator" />
          </div>
        </div>

        {/* RIGHT: Form Section */}
        <div className="contact-form-wrapper">
          <form onSubmit={handleSubmit} className="rfq-form">
            
            <div className="form-group">
              <label>Name</label>
              <input 
                type="text" 
                name="name" 
                placeholder="Name Surname" 
                onChange={handleChange} 
                required 
              />
            </div>

            <div className="form-group">
              <label>Email</label>
              <input 
                type="email" 
                name="email" 
                placeholder="name@domain.com" 
                onChange={handleChange} 
                required 
              />
            </div>

            <div className="form-group">
              <label>Phone Number</label>
              <input 
                type="tel" 
                name="phone" 
                placeholder="Phone Number" 
                onChange={handleChange} 
                required 
              />
            </div>

            <div className="form-group">
              <label>The Message</label>
              <p className="form-hint">Please give as much information as possible that will allow us to make the quotation as accurately as possible.</p>
              <textarea 
                name="message" 
                placeholder="Message text..." 
                rows="4"
                onChange={handleChange}
                required
              ></textarea>
            </div>

            <div className="form-submit">
              <Button 
                text="Submit" 
                variant="primary" 
                size="md" 
                type="submit"
              />
            </div>

          </form>
        </div>

      </div>
    </section>
  );
};

export default Contact;